// @flow
import React from 'react';
import Linkify from 'react-linkify';
import {apiBase} from '../../helpers/request';
import WarningText from '../WarningText/WarningText';
import DemoInfoBox from '../../components/DemoInfoBox/DemoInfoBox';

import './CustomerApartment.css';

const fileUrl = `${apiBase}/files`;

export type Props = {
  project: Object,
  showWarning: Boolean,
  showDemoText: Boolean,
};

const CustomerApartment = ({project, showWarning, showDemoText}: Props) => (
  <div className="CustomerApartment">
    <div className="CustomerApartmentHeader w-100">
      <div className="page-header" style={{alignSelf: 'flex-end'}}>
        <div className="page-title" >
          {project.name}
        </div>
      </div>
      <div  className="f-11" style={{width: '55%', marginLeft: '30px'}}>
        { showDemoText &&
            <DemoInfoBox />
        }
      </div>
    </div>
    <Linkify properties={{target: '_blank'}}>
      <p className="preserve-whitespace">{project.description}</p>
    </Linkify>
    {project.brochure &&
      <a
        href={`${fileUrl}/${project.brochure.id}?download`}
        target="_blank"
        className="file-link">
        Informationsbroschyr
      </a>
    }
    { showWarning &&
      <WarningText />
    }

  </div>
);

export default CustomerApartment;



// WEBPACK FOOTER //
// ./src/components/CustomerApartment/CustomerApartment.js